class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      // Keep open while focus remains inside this menu (e.g. after Enter toggle).
      if (!this.contains(document.activeElement)) this.close();
    }, 50);
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

function updateMegaMenuMainContentAccessibility() {
  const main = document.getElementById('MainContent');
  if (!main) return;

  const hasOpenMega = document.querySelector('.details-first-menu[open]');
  if (hasOpenMega) {
    main.inert = true;
    main.setAttribute('aria-hidden', 'true');
  } else {
    main.inert = false;
    main.removeAttribute('aria-hidden');
  }
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle.open;

      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', this.mainDetailsToggle.open ? 'true' : 'false');
      }

      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
      }
    }

    if (this.mainDetailsToggle.classList.contains('details-first-menu')) {
      updateMegaMenuMainContentAccessibility();
    }
  }
}

customElements.define('header-menu', HeaderMenu);

// Expose for hover handlers in component-header-dropdown-menu.js
window.updateMegaMenuMainContentAccessibility = updateMegaMenuMainContentAccessibility;
